export default "/images/git-commit.svg?ba691415c8d94f638dd9e29320b6f198";